module.exports = __webpack_public_path__ + "05e772318251c083aabf8f81912368eb.pdf";